import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'

export function RequestAgentCallbackErrorModal() {
  const intl = useIntl()
  return (
    <ModalBase>
      <form>
        <ModalHeader title={intl.formatMessage({
          id: '5YPiLJ5lPiyrkn9veV0P',
          defaultMessage: 'Callback request error',
          description: 'Heading title for callback request error modal in a modal dialog',
        })}
        />
        <ModalBody>
          <ModalContent>
            <VerticalSpacer gap={20}>
              <Group direction="vertical" gap={20}>
                <BodyTextBlock variant="large">
                  {intl.formatMessage({
                    id: 'H2nTs2afRH_vHTJSpL4F',
                    defaultMessage: 'There was an error scheduling your callback.',
                    description: 'Error message when callback scheduling fails when an issue occurs',
                  })}
                </BodyTextBlock>
              </Group>
            </VerticalSpacer>
          </ModalContent>
        </ModalBody>
        <ModalFooter primaryActionProps={{
          children: intl.formatMessage({
            id: 'xhDcfqBWlYOXTAaJNUTX',
            defaultMessage: 'Close',
            description: 'Close/dismiss button for callback error modal in a modal dialog',
          }),
        }}
        />
      </form>
    </ModalBase>
  )
}
